import React, { useState, useEffect } from 'react';
import greenBullet from '../assets/images/green-bullet.svg';
import './TeamPage.css';
import { Link } from 'react-router-dom';

const TeamPage = () => {
  const [activeCategory, setActiveCategory] = useState('all');
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const teamCategories = [
    { id: 'all', name: 'All' },
    { id: 'Investment Team', name: 'Investment Team' },
    { id: 'Firm Operations', name: 'Firm Operations' },
    { id: 'Firm Administration', name: 'Firm Administration' },
    { id: 'Advisors & Regional Partners', name: 'Advisors & Regional Partners' },
    { id: 'Digital Advisory Board', name: 'Digital Advisory Board' }
  ];

  const teamMembers = [
    {
      id: "Michael Attal",
      name: "Michael Attal",
      title: "Principal",
      category: "Investment Team",
      image: "https://d362w0t6uix91v.cloudfront.net/Assets/Bios/Bios/Michael-Attal.jpg",
      longDescription: "<p>Michael Attal is a Principal at BayPine. Previously, he was a Principal at Hellman & Friedman, where he focused on evaluating and executing investments in the healthcare and software sectors. Mr. Attal began his career as an investment banking analyst at Morgan Stanley in the Mergers & Acquisitions group.</p><p>Mr. Attal currently serves on the board of CenExel. &nbsp;Mr. Attal holds a BA in Financial Economics and Mathematics-Statistics from Columbia University in the City of New York.</p>"
    },
    {
      id: "Arth Baghel",
      name: "Arth Baghel",
      title: "Associate",
      category: "Investment Team",
      image: "https://d362w0t6uix91v.cloudfront.net/Assets/Bios/Bios/ArthBaghel12.jpg",
      longDescription: "<p>Arth Baghel is an Associate at BayPine. Previously, he was an Analyst in the Mergers & Acquisitions Group at Wells Fargo, where he worked across the industrials, consumer, energy and healthcare sectors and executed transactions for companies in the HVAC, biotechnology and CDMO spaces.  </p><p>Mr. Baghel holds a BS from the University of North Carolina at Chapel Hill and was a Wood Scholar.</p>"
    },
    {
      id: "Lindsay Beauregard",
      name: "Lindsay Beauregard",
      title: "Vice President, Compliance",
      category: "Firm Operations",
      image: "https://d362w0t6uix91v.cloudfront.net/Assets/Bios/Bios/LindsayBeauregard12V2.jpg",
      longDescription: "<p>Lindsay Beauregard is a Vice President&nbsp;on the Compliance team at BayPine. Previously she was a Principal Consultant at ACA Group, where she provided compliance consulting services for RIAs, with a focus on private funds. Prior to ACA she worked at Stone Coast Fund Services first in Investor Relations then Compliance and began her career at Harvard Business School in their Research and Faculty Development group.</p><p>Ms. Beauregard holds a BS from Bentley University.</p>"
    },
    {
      id: "Andy Cook",
      name: "Andy Cook",
      title: "Vice President",
      category: "Investment Team",
      image: "https://d362w0t6uix91v.cloudfront.net/Assets/Bios/AndyCook06.jpg",
      longDescription: "<p>Andy Cook is a Vice President at BayPine. Previously, he was a Senior Associate Consultant at Bain & Company, where he worked with clients across the private equity, technology and industrials sectors. </p><p>Mr. Cook currently serves on the Young Professionals Board of the Friends of the Children Boston chapter. Mr. Cook holds a BS in Mechanical Engineering and a BS in Mathematics from Southern Methodist University and was a Nancy Ann and Ray L. Hunt Leadership Scholar.</p>"
    },
    {
      id: "Jason Currier",
      name: "Jason Currier",
      title: "Partner and Chief Financial Officer",
      category: "Firm Operations",
      image: "https://d362w0t6uix91v.cloudfront.net/Assets/Bios/JasonCurrier09Cropped.jpg",
      longDescription: "<p>Jason Currier is a Partner and Chief Financial Officer at BayPine. Mr. Currier is responsible for financial reporting, valuations and administration of BayPine's private equity investments. Prior to BayPine, Mr. Currier was a Managing Director and Chief Financial Officer for Audax Private Equity, based in Boston.</p><p>Before joining Audax in 2017, he was a Vice President, Finance, at General Atlantic and previously served as Controller at Bessemer Venture Partners.  Earlier in his career, Mr. Currier served as a senior associate performing audit and business advisory services for private equity, venture capital and Fortune 500 clients at PricewaterhouseCoopers L.L.P.  </p><p>Mr. Currier holds a BS from Quinnipiac University and was a registered Certified Public Accountant in the State of Connecticut (currently inactive).</p>"
    },
    {
      id: "Erica David",
      name: "Erica David",
      title: "Principal, Investor Relations",
      category: "Firm Operations",
      image: "https://d362w0t6uix91v.cloudfront.net/Assets/Bios/Bios/EricaDavid_2025-04-21-160835_uqsc.jpg",
      longDescription: "<p>Erica David is a Principal on the Investor Relations team at BayPine. Before joining BayPine, she was a Vice President on the Investor Relationships team at American Securities, where she focused on investor relationships, marketing and fundraising.  Prior to that, Ms. David was on the Investor Relations team at BC Partners and also held roles in Private Capital Advisory at Lazard and in Alternative Investments at Morgan Stanley.</p><p> </p><p>Ms. David holds a BS from Cornell University and an MBA from the Wharton School of the University of Pennsylvania.</p>"
    },
    {
      id: "Cory A. Eaves",
      name: "Cory A. Eaves",
      title: "Partner & Portfolio Operations Lead",
      category: "Investment Team",
      image: "https://d362w0t6uix91v.cloudfront.net/Assets/Bios/CoreyEaves10Cropped.jpg",
      longDescription: "<p>Cory A. Eaves is a Partner and Head of Portfolio Operations at BayPine. Mr. Eaves leads the Firm's digital transformation and portfolio operations team, where his primary focus is on driving digital transformation initiatives within the firm and its portfolio companies. Prior to BayPine, Mr. Eaves was one of the first Operating Partners at General Atlantic, where he helped build and scale their portfolio value-add capability for nearly 15 years. </p><p>Before joining General Atlantic, he was Executive Vice President, Chief Technology Officer, and Chief Information Officer at Misys plc, a global provider of software and services to the healthcare and financial services industries. Earlier in his career, Mr. Eaves served as Chief Technology Officer of SSA Global, one of the world's largest enterprise software providers, and held various other technology leadership positions.</p><p>Mr. Eaves serves on the boards of CenExel, Penn Foster Group, the Marfan Foundation, where he was also a previous Chairman, and NetHope.  Mr. Eaves holds a BSEE from the University of Iowa and an MBA, cum laude, from Babson College.</p>"
    },
    {
      id: "Mara Edgar",
      name: "Mara Edgar",
      title: "Operating Partner, Talent",
      category: "Firm Operations",
      image: "https://d362w0t6uix91v.cloudfront.net/Assets/Bios/Bios/MaraEdgar41BaypineCrop.jpg",
      longDescription: "<p>Mara Lamoureux Edgar is an Operating Partner, Talent at BayPine, where she leads talent strategy and organizational effectiveness to support value creation across the firm and its investments. She partners with deal teams and portfolio company leaders on initiatives throughout the deal lifecycle, including pre- and post-investment diligence, C-suite and board recruitment, leadership development, and building capabilities for long-term growth.</p><p>Prior to joining BayPine, she was Managing Director of Human Capital at The Riverside Company. Earlier in her career, Ms. Edgar held senior roles at Parthenon Capital, Arrowroot Capital, and TA Associates, and served in global operational roles at Quintiles and Kantar Consulting.</p><p>Ms. Edgar serves as a Trustee of Parker School and is involved with 51 Vets and How Women Lead, supporting veterans and advancing diversity initiatives. She holds a J.D. from Suffolk University Law School, a B.A. from Wheaton College, and an Executive Coaching certification from Columbia University.</p>"
    },
    {
      id: "William Feng",
      name: "William Feng",
      title: "Vice President",
      category: "Investment Team",
      image: "https://d362w0t6uix91v.cloudfront.net/Assets/Bios/WilliamFeng30.jpg",
      longDescription: "<p>William Feng is a Vice President&nbsp;at BayPine. Previously, he was an Associate at Brightstar Capital Partners where he evaluated buyout transactions across a variety of industries, including consumer products, industrials, telecom and business services. Prior to Brightstar, he worked at Evercore Partners in their Investment Banking Division focused on restructuring and began his career at Goldman Sachs in their Private Equity Group. </p><p>Mr. Feng holds a BS from Boston University.</p>"
    },
    {
      id: "Steph Ferris",
      name: "Steph Ferris",
      title: "Executive Assistant",
      category: "Firm Administration",
      image: "https://d362w0t6uix91v.cloudfront.net/Assets/Bios/Bios/StephanieFerris17BaypineCrop.jpg",
      longDescription: "<p>Steph Ferris is an Executive Assistant at BayPine. Previously, she was an Executive Assistant at Thomas H. Lee Partners. Prior to that, Ms. Ferris held other administrative positions at Aeris Partners and Flybridge Capital Partners.  </p><p>Ms. Ferris holds a BA in Public Relations from Quinnipiac University.</p>"
    },
    {
      id: "Cat Flaherty",
      name: "Cat Flaherty",
      title: "Executive Assistant",
      category: "Firm Administration",
      image: "https://d362w0t6uix91v.cloudfront.net/Assets/Bios/Bios/CatFlaherty42BaypineCrop.jpg",
      longDescription: "<p>Cat Flaherty is an Executive Assistant at BayPine. She has over ten years experience working in the financial services industry and most recently served as the Executive Assistant to the Chief Executive Officer of Weiss Asset Management. Prior to that, Ms. Flaherty was an Executive Assistant to the investment team at RA Capital. Ms. Flaherty began her career as a Project Manager for the licensing team at Lillian August.</p><p> </p><p>Ms. Flaherty holds a BA from Endicott College.</p>"
    },
    {
      id: "William Fox",
      name: "William Fox",
      title: "Associate",
      category: "Investment Team",
      image: "https://d362w0t6uix91v.cloudfront.net/Assets/Bios/Bios/WillFox17.jpg",
      longDescription: "<p>William Fox is an Associate at BayPine.  Previously, he was an Analyst in the Restructuring Group at Lazard, where he worked on both in- and out-of-court recapitalizations, equity and debt capital raises, and distressed M&A opportunities across a variety of industries.</p><p> </p><p>Mr. Fox holds a BBA from the University of Notre Dame.</p>"
    },
    {
      id: "Erika Glass",
      name: "Erika Glass",
      title: "Director of Firm Administration",
      category: "Firm Administration",
      image: "https://d362w0t6uix91v.cloudfront.net/Assets/Bios/Erika-Glass-1.jpg",
      longDescription: "<p>Erika Glass is Director of Firm Administration at BayPine. Previously, she held various operations and administrative roles at PillPack, Bain Capital and SVG Advisers. Ms. Glass started her career as a music teacher at several Boston area schools. </p><p>Ms. Glass holds a BM from Berklee College of Music.</p>"
    },
    {
      id: "Marius Haas",
      name: "Marius Haas",
      title: "Founding Partner & Advisory Board Co-Chair",
      category: "Advisors & Regional Partners",
      image: "https://d362w0t6uix91v.cloudfront.net/Assets/Bios/MariusHaas31.jpg",
      longDescription: "<p>Marius Haas is a Founding Partner of BayPine. Mr. Haas has spent most of his career leading executive teams and organizations in the technology and enterprise solutions industry, and has significant expertise in digital transformation, emerging technologies, and B2B business models. His career includes senior leadership roles at Dell Technologies, Hewlett-Packard, Compaq and Intel Corporation. </p><p>Prior to BayPine, Mr. Haas served as President and Chief Commercial Officer of Dell Technologies, which had over $90 billion of revenue in fiscal year 2020. He played an instrumental role as a senior operating executive in the take-private of Dell in 2013, the subsequent integration of Dell, EMC, and VMware in 2016, and the strategic transformation of Dell from a commodity PC supplier into a leading provider of strategic technology infrastructure and managed enterprise solutions. </p><p>Mr. Haas currently serves on the boards of Harbor and HydroBlok NA. He also has&nbsp;served as an industry advisor to KKR's technology investment team. Mr. Haas holds a BA from Georgetown University and an MBA from the American Graduate School of Global Management.</p>"
    },
    {
      id: "Joel Hackney",
      name: "Joel Hackney",
      title: "Partner",
      category: "Investment Team",
      image: "https://d362w0t6uix91v.cloudfront.net/Assets/Bios/JoelHackney05.jpg",
      longDescription: "<p>Joel Hackney is a Partner of BayPine. With over 25 years of experience leading both private and public companies domestically and abroad, Mr. Hackney brings deep expertise in driving business transformation and growth. Most recently, he served as Chairman and CEO of nThrive, a healthcare information technology and revenue cycle solutions provider. </p><p>Prior to nThrive, Mr. Hackney was CEO and board member of AVINTIV, Inc., a $2 billion global innovator and manufacturer of specialty materials, Prior to AVINITV, he was an executive at Avaya, serving in a variety of roles including Senior Vice President of Global Sales and Marketing, President of Field Operations, and President of Government and Data Solutions. His extensive leadership experience also includes executive roles at Nortel and General Electric. </p><p>Mr. Hackney currently serves on the boards of Penn Foster Group, QualDerm Partners, and Training the Street. Mr. Hackney holds a BS from the University of North Carolina at Chapel Hill.</p>"
    },
    {
      id: "Emily Huckabee",
      name: "Emily Huckabee",
      title: "Administrative Assistant",
      category: "Firm Administration",
      image: "https://d362w0t6uix91v.cloudfront.net/Assets/Bios/Bios/EmilyHuckabee14BaypineCrop.jpg",
      longDescription: "<p>Emily Huckabee is an Administrative Assistant at BayPine. She has six years of administrative experience and most recently was the Receptionist for Beacon Capital Partners, a commercial real estate investment firm.</p><p>Ms. Huckabee holds a BFA in Animation from Massachusetts College of Art and Design.</p>"
    },
    {
      id: "Isabella Julian",
      name: "Isabella Julian",
      title: "Administrative Assistant",
      category: "Firm Administration",
      image: "https://d362w0t6uix91v.cloudfront.net/Assets/Bios/Bios/IsabellaJulian22BaypineCrop.jpg",
      longDescription: "<p>Isabella Julian is an Administrative Assistant at BayPine. She has eight years of administrative experience and most recently was the office manager at Ceras Health in Boston. </p><p> </p><p>Ms. Julian holds a BS in Business Management from Bentley University.</p>"
    },
    {
      id: "Drew Karchmer",
      name: "Drew Karchmer",
      title: "Senior Associate",
      category: "Investment Team",
      image: "https://d362w0t6uix91v.cloudfront.net/Assets/Bios/DrewKarchmer06.jpg",
      longDescription: "<p>Drew Karchmer is a Senior&nbsp;Associate at BayPine. Previously, he was an Associate at PJT Partners in their Global Strategic Advisory Group where he executed a variety of M&A and debt and equity financing transactions for companies in the communications, diversified industrials, transportation and technology sectors. </p><p>Mr. Karchmer holds a BBA from the University of Michigan.</p>"
    },
    {
      id: "Tim Kiely",
      name: "Tim Kiely",
      title: "Operating Principal",
      category: "Firm Operations",
      image: "https://d362w0t6uix91v.cloudfront.net/Assets/Bios/Bios/TimKiely12BaypineCrop.jpg",
      longDescription: "<p>Tim Kiely is an Operating Principal at BayPine and the Head of Data, Analytics, and AI. Mr. Kiely specializes in driving investment value through data-driven and model-based decision-making across sourcing, due diligence, and portfolio operations.</p><p>Previously, Mr. Kiely served as the Head of Data Science at American Securities, a private equity firm based in New York, where he led initiatives to leverage data for strategic insights and operational improvements.</p><p>Mr. Kiely holds a BA from Williams College and a MS in Data Science from Northwestern University.</p>"
    },
    {
      id: "Steve Ko",
      name: "Steve Ko",
      title: "Founding Partner",
      category: "Investment Team",
      image: "https://d362w0t6uix91v.cloudfront.net/Assets/Bios/SteveKo10V4.jpg",
      longDescription: "<p>Steve Ko is a Founding Partner of BayPine. Mr. Ko has more than 25 years of private equity industry experience and has been involved with numerous transactions at several of the world's most prominent investment firms. Most recently, he was a Managing Director and head of KKR's Consumer and Retail investment team in the Asia-Pacific region.&nbsp;Previously he was a member of KKR's North American private equity platform and also held roles at Blackstone, Clayton, Dubilier & Rice and Goldman Sachs.</p><p>Mr. Ko has executed multiple transactions in the consumer, healthcare, industrial, business services, energy and technology sectors, across an extensive range of company situations, transaction and financing structures, and geographies. </p><p>Mr. Ko has significant public and private board experience and currently serves on the boards of POLYWOOD, QualDerm Partners and&nbsp;New Frontier Materials. Mr. Ko holds an AB from Harvard College, an M.Phil from Cambridge University and an MBA from Harvard Business School.</p>"
    },
    {
      id: "Aamir Lacewala",
      name: "Aamir Lacewala",
      title: "Analyst",
      category: "Investment Team",
      image: "https://d362w0t6uix91v.cloudfront.net/Assets/Bios/Bios/AamirLacewala16.jpg",
      longDescription: "<p>Aamir Lacewala is an Analyst at BayPine. Previously, he was a Summer Analyst at Blackstone in the Acquisitions group, where he evaluated real estate investment opportunities across multifamily, industrial, office, and data center assets. </p><p> </p><p>Mr. Lacewala holds a BS in Economics from the Wharton School and a BA in International Studies from the University of Pennsylvania, through the Huntsman Program for International Studies and Business.</p>"
    }
  ];

  const handleCategoryClick = (category) => {
    setActiveCategory(category);
  };

  const handleEmployeeClick = (employee) => {
    setSelectedEmployee(employee);
    setIsModalOpen(true);
    document.body.style.overflow = 'hidden'; // Prevent scrolling when modal is open
  };

  const closeModal = () => {
    setIsModalOpen(false);
    document.body.style.overflow = 'auto'; // Re-enable scrolling
  };

  // Close modal when clicking outside of it
  const handleModalBackdropClick = (e) => {
    if (e.target.classList.contains('employee-modal-backdrop')) {
      closeModal();
    }
  };

  // Close modal when pressing Escape key
  useEffect(() => {
    const handleEscKey = (e) => {
      if (e.key === 'Escape' && isModalOpen) {
        closeModal();
      }
    };

    window.addEventListener('keydown', handleEscKey);
    return () => {
      window.addEventListener('keydown', handleEscKey);
      // Reset body overflow when component unmounts
      document.body.style.overflow = 'auto';
    };
  }, [isModalOpen]);

  const filteredTeamMembers = activeCategory === 'all' 
    ? teamMembers 
    : teamMembers.filter(member => member.category === activeCategory);

  return (
    <div className="team-page">
      <div className="team-hero">
        <div className="container">
          <h1 className="team-hero-title">Experienced investors alongside technologically-fluent operators</h1>
          <p className="team-hero-subtitle">
            With deep expertise from startups to global corporations, our team has the foundation to excel in modernization, change management and sustainable innovation.
          </p>
        </div>
      </div>

      <section className="team-members-section">
        <div className="team-container margin-left margin-right">
          <div className="team-filter-container">
            <div className="team-categories margin-bottom">
              {teamCategories.map((category) => (
                <button 
                  key={category.id}
                  type="button" 
                  data-team={category.id} 
                  className={activeCategory === category.id ? 'active' : ''}
                  onClick={() => handleCategoryClick(category.id)}
                >
                  {category.name}
                </button>
              ))}
            </div>
          </div>

          <div className="team-section row active" data-team={activeCategory}>
            {filteredTeamMembers.map((member) => (
              <div 
                key={member.id}
                className="col-12 col-md-4 col-lg-3 employee" 
                data-long-description={member.longDescription}
                data-title={member.title}
                data-name={member.name}
                data-id={member.id}
                data-small-picture={member.image}
              >
                <div className="employee-container" onClick={() => handleEmployeeClick(member)}>
                  <div className="team-image">
                    <img style={{ width: '100%' }} className="zoo" src={member.image} alt={member.name} />
                  </div>
                  <div className="team-text">
                    <p className="team-text__name cormorant margin-bottom-none neutral-700">{member.name}</p>
                    <p className="team-text__title lexend neutral-500 body">{member.title}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Employee Modal */}
      {isModalOpen && selectedEmployee && (
        <div className="employee-modal-backdrop" onClick={handleModalBackdropClick}>
          <div className="employee-modal">
            <button className="modal-close-btn" onClick={closeModal}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
            <div className="modal-content">
              <div className="modal-image">
                <img src={selectedEmployee.image} alt={selectedEmployee.name} />
              </div>
              <div className="modal-details">
                <h2 className="modal-name">{selectedEmployee.name}</h2>
                <p className="modal-title">{selectedEmployee.title}</p>
                <div 
                  className="modal-description"
                  dangerouslySetInnerHTML={{ __html: selectedEmployee.longDescription }}
                />
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Contact Section */}
      <section className="contact-section">
          <div className="contact-grid">
            <div className="contact-item talk-with-us">
              <h3 className="contact-title">
                <img src={greenBullet} alt="" className="bullet-image" />
                TALK WITH US
              </h3>
              <p className="contact-description">
                We're always eager to make new connections and provide more information.
              </p>
              <Link to="/contact" className="contact-link">
                GET IN TOUCH
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path d="M17.7387 12.6259L13.4506 17.0037C13.2898 17.1679 13.0754 17.25 12.861 17.25C12.6198 17.25 12.4054 17.1679 12.2446 17.0037C11.8961 16.6754 11.8961 16.1008 12.2446 15.7725L15.0586 12.8721H6.85762C6.37521 12.8721 6 12.4891 6 11.9966C6 11.5314 6.37521 11.121 6.85762 11.121H15.0586L12.2446 8.24805C11.8961 7.91971 11.8961 7.34511 12.2446 7.01678C12.5662 6.66107 13.129 6.66107 13.4506 7.01678L17.7387 11.3946C18.0871 11.723 18.0871 12.2976 17.7387 12.6259Z" fill="currentColor"/>
                </svg>
              </Link>
            </div>
            <div className="contact-item join-us">
              <h3 className="contact-title">
                <img src={greenBullet} alt="" className="bullet-image" />
                JOIN US
              </h3>
              <p className="contact-description">
                Join our dynamic and ambitious team.
              </p>
              <a href="mailto:Careers@BayPine.com" className="contact-link">
                INQUIRE ABOUT AVAILABLE OPPORTUNITIES
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path d="M17.7387 12.6259L13.4506 17.0037C13.2898 17.1679 13.0754 17.25 12.861 17.25C12.6198 17.25 12.4054 17.1679 12.2446 17.0037C11.8961 16.6754 11.8961 16.1008 12.2446 15.7725L15.0586 12.8721H6.85762C6.37521 12.8721 6 12.4891 6 11.9966C6 11.5314 6.37521 11.121 6.85762 11.121H15.0586L12.2446 8.24805C11.8961 7.91971 11.8961 7.34511 12.2446 7.01678C12.5662 6.66107 13.129 6.66107 13.4506 7.01678L17.7387 11.3946C18.0871 11.723 18.0871 12.2976 17.7387 12.6259Z" fill="currentColor"/>
                </svg>
              </a>
            </div>
          </div>
      </section>

    </div>
  );
};

export default TeamPage;
